import { CLIENTS } from "../../data/content";

export const ClientTicker = () => (
  <div style={{
    background: "var(--surface)", borderTop: "1px solid var(--border)",
    borderBottom: "1px solid var(--border)", paddingBlock: "var(--space-5)",
  }} aria-label="Clients and partners">
    <div className="client-ticker">
      <div className="client-ticker-inner" aria-hidden="true">
        {[...CLIENTS, ...CLIENTS].map((c, i) => (
          <span className="client-badge" key={`${c}-${i}`}>{c}</span>
        ))}
      </div>
    </div>
  </div>
);
